import { useEffect } from 'react';

import { usePathname, useSearchParams } from 'next/navigation';

import { pageEvent } from '../../helpers/analytics';
import { useClientHasRendered } from '../../helpers/hooks';
import { useReactAxe } from '../../helpers/hooks/useReactAxe';
import { useAnalytics } from '../../contexts/AnalyticsContext/AnalyticsContext';
import { useAmplitudePageView } from '../../contexts/AnalyticsContext/hooks/useAmplitudePageView';
import { datadogRum } from '@datadog/browser-rum-slim';

type IProps = {
  blockDatadogRum?: boolean;
};

export const PageViewHandler = ({ blockDatadogRum }: IProps) => {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const clientHasRendered = useClientHasRendered();
  const { currentPage, currentPageTitle, currentPageId, currentPageSubject, previousPage } =
    useAnalytics();

  useAmplitudePageView({
    page: currentPage,
    pageTitle: currentPageTitle,
    pageId: currentPageId,
    pageSubject: currentPageSubject,
    previousPage,
  });

  useEffect(() => {
    if (clientHasRendered && !blockDatadogRum) {
      datadogRum.startView(currentPage);
    }
  }, [clientHasRendered, currentPage, blockDatadogRum]);

  useEffect(() => {
    if (clientHasRendered && pathname && searchParams) {
      pageEvent(pathname, searchParams, currentPageTitle);
    }
  }, [currentPageTitle, clientHasRendered, pathname, searchParams]);

  useReactAxe(clientHasRendered);

  return null;
};
